export const hasActiveEffect = (activeEffects, targetCombatantId, definitionId) =>
  (activeEffects || []).some((effect) =>
    String(effect?.targetCombatantId ?? '') === String(targetCombatantId ?? '') &&
    effect?.definitionId === definitionId);
